interface FilterPanelProps {
  genreOptions: string[];
  decadeOptions: string[];
  regionOptions: string[];
  selectedGenres: string[];
  selectedDecades: string[];
  selectedRegions: string[];
  onToggle: (group: 'genre' | 'decade' | 'region', value: string) => void;
  onReset: () => void;
}

function FilterGroup({
  title,
  options,
  selected,
  group,
  onToggle,
  showDivider,
}: {
  title: string;
  options: string[];
  selected: string[];
  group: 'genre' | 'decade' | 'region';
  onToggle: (group: 'genre' | 'decade' | 'region', value: string) => void;
  showDivider: boolean;
}) {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3.5 ${showDivider ? 'border-t border-background-200' : ''}`}>
      <span className="text-sm font-medium text-foreground-700 shrink-0 w-16 pt-1">{title}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isActive = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(group, option)}
              className={`px-3 py-1.5 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  genreOptions,
  decadeOptions,
  regionOptions,
  selectedGenres,
  selectedDecades,
  selectedRegions,
  onToggle,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 px-4 md:px-5 py-2">
      <FilterGroup
        title="类型"
        options={genreOptions}
        selected={selectedGenres}
        group="genre"
        onToggle={onToggle}
        showDivider={false}
      />
      <FilterGroup
        title="年代"
        options={decadeOptions}
        selected={selectedDecades}
        group="decade"
        onToggle={onToggle}
        showDivider
      />
      <FilterGroup
        title="地区"
        options={regionOptions}
        selected={selectedRegions}
        group="region"
        onToggle={onToggle}
        showDivider
      />
      <div className="flex items-center justify-between border-t border-background-200 py-3.5">
        <span className="text-xs text-foreground-500">可按类型、年代、地区组合筛选</span>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}